import React from 'react';
import classnames from 'classnames';
import PropTypes from 'prop-types';

import ArrowDropDownOutlinedIcon from '@mui/icons-material/ArrowDropDownOutlined';
import i18n from 'i18next';

import { Button } from 'uikit/buttons';
import { Menu } from 'uikit/menus';

import { getMenuItems, useDashboards } from '@/exceed';

import tabsStyles from '../../exceed/styles/tabs.module.scss';
import styles from '../styles/insightsTab.module.scss';

const InsightsTab = ({ id }) => {
  const { dashboards } = useDashboards({ id, type: 'Course' });

  const menuItems = getMenuItems(
    dashboards.data?.map((dashboard) => ({
      key: dashboard.display_name,
      onClick: () =>
        window.open(
          `/dashboards/${dashboard.id}?dashboardable_type=Course&dashboardable_id=${id}`,
          '_blank',
        ),
    })) || [],
  );

  return (
    <Menu
      component={
        <Button
          className={classnames(styles.element, tabsStyles.link, tabsStyles.isHorizontal)}
          icon={<ArrowDropDownOutlinedIcon />}
          iconPosition="right"
          iconSize={18}
          isDisabled={!dashboards.isSuccess}
          size="xsmall"
          text={i18n.t('insights')}
          variant="link"
        />
      }
      contentClassName={styles.menu}
      horizontalPosition="left"
    >
      {menuItems}
    </Menu>
  );
};

InsightsTab.propTypes = {
  id: PropTypes.number.isRequired,
};

export default InsightsTab;
